import { cncMiniLazyload } from '@default/scripts/modules/lazy-load/cncMiniLazyload';
import { captcha } from './modules/captcha';
import { form } from './modules/30-years/form';

cncMiniLazyload();
captcha();
form();

/**
 * Timeline TOP titles // Vue.js 2
 *
 */
const timelineTopTitlesInit = async () => {
    const timeline = document.querySelector('[data-timeline-top-titles]');

    if (timeline) {
        const { timelineTopTitles } = await import(
            /* webpackChunkName: 'chunk-blesk30-timelineTopTitles' */
            './modules/30-years/timelineTopTitles'
        );

        timelineTopTitles();
        cncMiniLazyload();
    }
};

/**
 * Horní navigace - responsivní verze // Vue.js 2
 *
 */
const topNavInit = async () => {
    const topNavElement = document.querySelector('#top-nav');

    if (topNavElement) {
        await import(
            /* webpackChunkName: 'chunk-blesk30-topNav' */
            './modules/30-years/topNav'
        );
    }
};

/**
 * Carousel velkých fotek v článku
 *
 */
const articleGalleryBigInit = async () => {
    const articleGalleryBigElement = document.querySelector('.article__gallery-big');

    if (articleGalleryBigElement) {
        const { articleGalleryBig } = await import(
            /* webpackChunkName: 'chunk-blesk30-articleGalleryBig' */
            './modules/30-years/articleGalleryBig'
        );

        articleGalleryBig();
    }
};

/** Spusteni dynamickych importu */
const loadDynamicImports = () => {
    timelineTopTitlesInit();
    topNavInit();
    articleGalleryBigInit();
};

loadDynamicImports();
